// extracted by mini-css-extract-plugin
module.exports = {"list":"QuoteList_list__3pzcl","sorting":"QuoteList_sorting__rL6H1"};